export default __webpack_public_path__ + "static/media/yellowCircle.64df54f8.svg";